import { Controller } from 'front-end-core/core/Router'
import getUrl from 'front-end-core/core/url'

import Header from './Header'
import Main from 'redux/containers/pages/precedentscontent/PermissionsCheckContainer'
import { DOCUMENTS_CONTENT } from 'constants/controllers'

export default new Controller({
  name: DOCUMENTS_CONTENT,
  route: ':aol/documents/:view(/:sectionId(/e/:expanded)(/:precedentId))',
  controller (Router, { scrollMain, url, query, params: { aol, view, sectionId = null, precedentId = null, expanded = null } }, render) {
    const pageId = getUrl(DOCUMENTS_CONTENT, { aol, view, sectionId, precedentId })

    render(
      { Header, Main },
      {
        view,
        sectionId,
        precedentId,
        expandedSection: expanded,
        aol
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol
      }
    )

    return pageId
  }
})
